import React from 'react';
import Dialog from '@mui/material/Dialog';
import DialogTitle from '@mui/material/DialogTitle';
import DialogContent from '@mui/material/DialogContent';
import DialogActions from '@mui/material/DialogActions';
import Button from '@mui/material/Button';
import Typography from '@mui/material/Typography';
import Box from '@mui/material/Box';
import CircularProgress from '@mui/material/CircularProgress';

/**
 * DeleteEventDialog - Confirmation dialog for deleting events
 * @param {boolean} open - Whether the dialog is open
 * @param {Object} event - Event to delete
 * @param {Array} allEvents - All events (to check for associated events)
 * @param {Function} onClose - Callback when dialog is closed
 * @param {Function} onConfirm - Callback when delete is confirmed
 * @param {boolean} loading - Whether deletion is in progress
 */
export default function DeleteEventDialog({
  open,
  event,
  allEvents,
  onClose,
  onConfirm,
  loading = false
}) {
  if (!event) return null;

  return (
    <Dialog open={open} onClose={onClose} maxWidth="sm" fullWidth>
      <DialogTitle>Delete Event</DialogTitle>
      <DialogContent>
        <Typography variant="body1" sx={{ mb: 2 }}>
          Are you sure you want to delete this event?
        </Typography>
        <Box>
          <Typography variant="body2" color="text.secondary">
            <strong>Description:</strong> {event.description}
          </Typography>
          <Typography variant="body2" color="text.secondary">
            <strong>Type:</strong> {event.eventType}
          </Typography>
        </Box>
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose} disabled={loading}>
          Cancel
        </Button>
        <Button onClick={onConfirm} disabled={loading} variant="contained" color="error">
          {loading ? <CircularProgress size={24} /> : 'Delete'}
        </Button>
      </DialogActions>
    </Dialog>
  );
}
